var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4001 9.0001C17.4001 13.6393 13.6393 17.4001 9.0001 17.4001C4.36091 17.4001 0.600098 13.6393 0.600098 9.0001C0.600098 4.36091 4.36091 0.600098 9.0001 0.600098C13.6393 0.600098 17.4001 4.36091 17.4001 9.0001ZM10.0501 13.2001C10.0501 13.78 9.58 14.2501 9.0001 14.2501C8.4202 14.2501 7.9501 13.78 7.9501 13.2001C7.9501 12.6202 8.4202 12.1501 9.0001 12.1501C9.58 12.1501 10.0501 12.6202 10.0501 13.2001ZM9.0001 3.7501C8.4202 3.7501 7.9501 4.2202 7.9501 4.8001V9.0001C7.9501 9.58 8.4202 10.0501 9.0001 10.0501C9.58 10.0501 10.0501 9.58 10.0501 9.0001V4.8001C10.0501 4.2202 9.58 3.7501 9.0001 3.7501Z",
    fill: "#DF6400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingIcon);
export default __webpack_public_path__ + "static/media/pending_icon.5cc68c8b4f174b3205fb32643f8f0675.svg";
export { ForwardRef as ReactComponent };